module.exports = __webpack_public_path__ + "img/22.7873504c.gif";